import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';

export default function MarketIntelligencePreviewGate({ children }: { children: ReactNode }) {
    const { user } = useAuth();

    // 认证加载由 AuthContext 管理；用户尚未恢复时不挂载业务页面，也不提前跳转。
    if (!user) return null;

    return <>{children}</>;
}
